/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay]);
import customEventsNames from './../customEventsNames';
import 'swiper/css/pagination';
export function slider() {

    const navigationProductCardsSliderSelector = ".navigation-section__products.swiper";
    const productCardsSliderSelector = ".product-cards__cards.swiper";
    const projectsCardsSliderSelector = ".projects-cards__cards.swiper";
    const articleCardsSliderSelector = ".articles-list-container.swiper";
    const accordionSliderSelector = ".accordion-slider__slides-slider.swiper";
    const productVariantSliderSelector = ".product-variant__images-slider.swiper";
    const imageSliderSelector = ".image-slider__inner.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Accordion sliders
        const accordionSliders = [];
        const accordionSliderElements = document.querySelectorAll(accordionSliderSelector);
        if (accordionSliderElements) {
            accordionSliderElements.forEach(slider => {

                const swiperSlider = new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '#' +slider.dataset.componentId + " .slider-navigation__next",
                        prevEl:'#' +slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: (swiper) => {
                            handleSlideChange();

                            const accordion = slider.closest('.accordion-slider').querySelector('.accordion');
                            const accordionItem = accordion.querySelectorAll('.accordion__item')[swiper.activeIndex];
                            const accordionId = accordion.dataset.accordionId;
                            const accordionItemId = accordionItem.dataset.accordionItemId;
                            const accordionItemIndex = swiper.activeIndex;

                            const activateAccordionItemEvent = new CustomEvent(customEventsNames.accordionActivateItemEventName, {
                                detail: {
                                    accordionId: accordionId,
                                    accordionItemId: accordionItemId,
                                    accordionItemIndex: accordionItemIndex,
                                    deactivateAllItems: true
                                }
                            });
                            accordion.dispatchEvent(activateAccordionItemEvent);
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                });

                slider.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    swiperSlider.slideTo(e.detail.accordionItemIndex);
                });
                accordionSliders.push(swiperSlider);
            })
        }

        //Products sliders
        const productSliders = [];
        const productSlidersElements = [];
        productSlidersElements.push(...document.querySelectorAll(navigationProductCardsSliderSelector));
        productSlidersElements.push(...document.querySelectorAll(productCardsSliderSelector));
        if (productSlidersElements) {
            productSlidersElements.forEach(slider => {
                productSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                    navigation: {
                        nextEl: '#' +slider.dataset.componentId + " .slider-navigation__next",
                        prevEl:'#' +slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Product variant slider
        const productVariantSliderElement = document.querySelector(productVariantSliderSelector);
        if (productVariantSliderElement) {
            const productVariantSlider = new Swiper(productVariantSliderElement, {
                speed: 500,
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: ".slider-pagination",
                    type: "fraction",
                },
                navigation: {
                    nextEl: productVariantSliderSelector + " .slider-navigation__next",
                    prevEl: productVariantSliderSelector + " .slider-navigation__prev",
                },
                on: {
                    slideChange: () => {
                        handleSlideChange();
                    },
                    slideChangeTransitionEnd: (swiper) => {
                        handleSlideChangeTransitionEnd(swiper);

                    }
                }
            });
        }

        //Projects sliders
        const projectsSliders = [];
        const projectsSliderElements = document.querySelectorAll(projectsCardsSliderSelector);
        if (projectsSliderElements) {
            projectsSliderElements.forEach(slider => {

                projectsSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 'auto',
                    spaceBetween: 40,
                    navigation: {
                        nextEl: '#' +slider.dataset.componentId + " .slider-navigation__next",
                        prevEl:'#' +slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Article sliders
        const articleSliders = [];
        const articleSliderElements = document.querySelectorAll(articleCardsSliderSelector);
        if (articleSliderElements) {
            articleSliderElements.forEach(slider => {

                articleSliders.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 'auto',
                    spaceBetween: 40,
                    navigation: {
                        nextEl: '#' +slider.dataset.componentId + " .slider-navigation__next",
                        prevEl:'#' +slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        // Image Slider
        const imageSlider = [];
        const imageSliderElements = document.querySelectorAll(imageSliderSelector);
        if (imageSliderElements) {
            imageSliderElements.forEach(slider => {

                imageSlider.push(new Swiper(slider, {
                    slidesPerView: 1,
                    spaceBetween: 15,
                    autoplay: {
                        disableOnInteraction: false,
                        delay: 7500,
                        waitForTransition: true,
                    },
                    centeredSlides: true,
                    loop: true,
                    pagination: {
                        el: ".image-slider__slider-pagination",
                        clickable: true,
                      },
                      navigation: {
                        nextEl: '#' +slider.dataset.componentId + " .image-slider__slider-navigation__next",
                        prevEl:'#' +slider.dataset.componentId + " .image-slider__slider-navigation__prev",
                    },
                    breakpoints: {
                        992: {
                            spaceBetween: 30,
                        }
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    };

    init();
}
